import React from 'react';
import PropTypes from 'prop-types';
import styles from './ConfirmationInfo.module.scss';

const ConfirmationInfo = ({ children, checkoutToken }) => {
  return (
    <>
      <section className={styles['confirmation-details']}>
        <h1 className="display-heading-03">Licensing purchase completed</h1>
        <p className={styles['confirmation-details__confirmation-number']}>Confirmation number: {checkoutToken}</p>
        {children}
        <div className={styles['confirmation-details__background-extension']} data-testid="confirmation-bg-extension" />
      </section>
    </>
  );
};

ConfirmationInfo.propTypes = {
  children: PropTypes.node.isRequired,
  checkoutToken: PropTypes.string.isRequired,
};

export default ConfirmationInfo;
